__turbopack_context__.v({
  "bottomIcon": "WhyCard-module-scss-module__jsHFMq__bottomIcon",
  "bottomIconHover": "WhyCard-module-scss-module__jsHFMq__bottomIconHover",
  "card": "WhyCard-module-scss-module__jsHFMq__card",
  "content": "WhyCard-module-scss-module__jsHFMq__content",
  "hoverIcon": "WhyCard-module-scss-module__jsHFMq__hoverIcon",
  "hovered": "WhyCard-module-scss-module__jsHFMq__hovered",
  "icon": "WhyCard-module-scss-module__jsHFMq__icon",
  "iconWrap": "WhyCard-module-scss-module__jsHFMq__iconWrap",
  "slideInGradient": "WhyCard-module-scss-module__jsHFMq__slideInGradient",
  "subtitle": "WhyCard-module-scss-module__jsHFMq__subtitle",
  "textWrap": "WhyCard-module-scss-module__jsHFMq__textWrap",
  "title": "WhyCard-module-scss-module__jsHFMq__title",
});
